import { Wand2 } from "lucide-react"

import { FeatureCard } from "./feature-card"
import { MockCardOverlay } from "./mock-data-wrapper"

interface ComingSoonCardProps {
  animationDelay?: number
}

export function ComingSoonCard({ animationDelay = 0 }: ComingSoonCardProps) {
  return (
    <FeatureCard
      title="Plan Maker"
      icon={Wand2}
      iconColor="text-amber-600 dark:text-amber-400"
      iconBgColor="bg-amber-100 dark:bg-amber-900/30"
      animationDelay={animationDelay}
    >
      <MockCardOverlay message="Coming soon">
        <div className="space-y-4 text-center">
          <div className="bg-muted/50 mx-auto size-16 rounded-full" />
          <div className="space-y-2">
            <p className="text-foreground text-sm font-medium">
              AI-Powered Learning Plans
            </p>
            <p className="text-muted-foreground text-xs">
              Tell us your goals and we'll create a personalized Thai learning
              journey.
            </p>
          </div>
        </div>
      </MockCardOverlay>
    </FeatureCard>
  )
}
